var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulplitlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 52,
    viewBox: "0 0 116 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0899 20.0597C7.4599 18.4797 7.96992 17.0497 8.63992 15.7997C9.29992 14.5397 10.0899 13.4797 11.0099 12.6097C11.9299 11.7397 12.9599 11.0697 14.1199 10.6097C15.2799 10.1397 16.5299 9.90967 17.8899 9.90967C19.1199 9.90967 20.2799 10.0897 21.3799 10.4497C22.4799 10.8097 23.4999 11.3197 24.4299 11.9797C25.3599 12.6397 26.1999 13.4497 26.9499 14.4097C27.6999 15.3597 28.3299 16.4397 28.8599 17.6197C29.3899 18.8097 29.7899 20.1097 30.0699 21.5097C30.3499 22.9197 30.4899 24.3997 30.4899 25.9697C30.4899 27.5397 30.3499 29.0197 30.0699 30.4297C29.7899 31.8397 29.3899 33.1297 28.8599 34.3197C28.3299 35.5097 27.6999 36.5797 26.9499 37.5297C26.1999 38.4797 25.3599 39.2897 24.4299 39.9597C23.4899 40.6297 22.4799 41.1397 21.3799 41.4997C20.2799 41.8597 19.1199 42.0397 17.8899 42.0397C16.5399 42.0397 15.2899 41.8097 14.1399 41.3397C12.9799 40.8697 11.9499 40.1997 11.0299 39.3297C10.1099 38.4497 9.31991 37.3897 8.65991 36.1397C7.99991 34.8897 7.47989 33.4697 7.10989 31.8797V51.6597H0.169922V10.7397H7.10989V20.0597H7.0899ZM7.0899 25.9597C7.0899 27.5497 7.2799 28.9597 7.6499 30.1997C8.0199 31.4397 8.56991 32.4997 9.27991 33.3597C9.98991 34.2197 10.8599 34.8797 11.8899 35.3297C12.9199 35.7797 14.0799 36.0097 15.3799 36.0097C16.7099 36.0097 17.8699 35.7897 18.8799 35.3597C19.8899 34.9297 20.7399 34.2897 21.4199 33.4397C22.1099 32.5897 22.6199 31.5397 22.9699 30.2997C23.3199 29.0497 23.4899 27.6097 23.4899 25.9697C23.4899 24.3297 23.3099 22.8897 22.9699 21.6397C22.6199 20.3897 22.0999 19.3497 21.4199 18.4997C20.7299 17.6597 19.8899 17.0197 18.8799 16.5897C17.8699 16.1597 16.6999 15.9397 15.3799 15.9397C14.0699 15.9397 12.8999 16.1697 11.8799 16.6197C10.8499 17.0697 9.9799 17.7297 9.2699 18.5797C8.5599 19.4397 8.0199 20.4897 7.6499 21.7297C7.2699 22.9597 7.0899 24.3797 7.0899 25.9597Z",
    fill: "#1E2126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2699 10.73H62.2099V41.2H55.2699V32.23C54.9299 33.78 54.4299 35.16 53.7699 36.38C53.1099 37.6 52.3099 38.62 51.3799 39.46C50.4399 40.3 49.3799 40.94 48.1799 41.37C46.9799 41.81 45.6699 42.03 44.2599 42.03C42.5699 42.03 41.0699 41.72 39.7599 41.1C38.4499 40.48 37.3399 39.57 36.4299 38.38C35.5199 37.19 34.8299 35.73 34.3599 34.01C33.8899 32.28 33.6599 30.31 33.6599 28.1V10.73H40.5999V27.41C40.5999 33.07 42.8899 35.9 47.4699 35.9C48.7099 35.9 49.8099 35.7 50.7699 35.31C51.7299 34.92 52.5599 34.34 53.2199 33.58C53.8899 32.82 54.3999 31.88 54.7499 30.77C55.0999 29.66 55.2699 28.4 55.2699 26.98V10.73Z",
    fill: "#1E2126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1899 0.299805V22.9998H73.1099V0.299805H66.1899Z",
    fill: "#1E2126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8499 22.9897H71.9299V41.1998H78.8499V22.9897Z",
    fill: "#1E2126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1399 20.3896H67.9199V25.6096H73.1399V20.3896Z",
    fill: "#1E2126"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.73 20.3896H70.51V25.6096H75.73V20.3896Z",
    fill: "#1E2126"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7598 10.7295H82.8198V51.6395H89.7598V10.7295Z",
    fill: "#1E2126"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.84 25.9595H110.63V31.1794H115.84V25.9595Z",
    fill: "#1E2126"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.84 20.7495H110.63V25.9595H115.84V20.7495Z",
    fill: "#1E2126"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.63 15.5298H105.41V20.7498H110.63V15.5298Z",
    fill: "#1E2126"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.63 31.1797H105.41V36.3997H110.63V31.1797Z",
    fill: "#1E2126"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 36.3994H100.2V41.6194H105.42V36.3994Z",
    fill: "#1E2126"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 36.3994H94.9797V41.6194H100.2V36.3994Z",
    fill: "#1E2126"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9698 31.1797H89.7598V36.3997H94.9698V31.1797Z",
    fill: "#1E2126"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 10.3096H100.2V15.5296H105.42V10.3096Z",
    fill: "#1E2126"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 10.3096H94.9797V15.5296H100.2V10.3096Z",
    fill: "#1E2126"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9698 15.5298H89.7598V20.7498H94.9698V15.5298Z",
    fill: "#1E2126"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8199 49.0396H77.5999V51.6496H82.8199V49.0396Z",
    fill: "#1E2126"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8199 10.7295H77.5999V13.3395H82.8199V10.7295Z",
    fill: "#1E2126"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9798 49.0396H89.7598V51.6496H94.9798V49.0396Z",
    fill: "#1E2126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulplitlogo);
export default __webpack_public_path__ + "static/media/pulplitlogo.4b8d40c1c76de98278385bcf047b6e36.svg";
export { ForwardRef as ReactComponent };